import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { RootState } from "../redux/store";
import { getCookie } from "../utils/cookieUtils";

const useAuthRedirect = () => {
  const { isAuthenticated } = useSelector((state: RootState) => state.auth);
  const navigate = useNavigate();

  useEffect(() => {
    const jwtToken = getCookie("authToken");

    // Redirect only if the user is authenticated and has a token
    if (isAuthenticated && jwtToken) {
      navigate("/registration/init");
    }
  }, [isAuthenticated, navigate]);
};

export default useAuthRedirect;
